import 'prop-types';
import React from 'react';
import _isEqual from 'lodash/isEqual';
import { usePersonalPayment } from './usePersonalPayment.js';
import Payment from '../Payment/Payment.js';
import { jsx } from 'react/jsx-runtime';
function PersonalPayment(_ref) {
  let {
    textColor,
    price,
    paymentsInfo,
    uiContext,
    vehicleCondition,
    personalizedPayment,
    shouldUpdatePayment = true,
    handleFallbackPayment = () => {}
  } = _ref;
  const payment = usePersonalPayment({
    price,
    paymentsInfo,
    vehicleCondition,
    personalizedPayment,
    shouldUpdatePayment,
    handleFallbackPayment
  });
  return /*#__PURE__*/jsx(Payment, {
    payment: payment,
    uiContext: uiContext,
    ...(textColor ? {
      textColor
    } : {})
  });
}
/**
 * Returns a computed payment based on inputs or provided payment object, displayed with "$/mo".
 * If you do not need the calculation, use the `<Payment />` component directly for just formatting.
 *
 * @component
 */
var PersonalPayment$1 = /*#__PURE__*/React.memo(PersonalPayment, (prevProps, nextProps) => _isEqual(prevProps.paymentsInfo, nextProps.paymentsInfo) && _isEqual(prevProps.personalizedPayment, nextProps.personalizedPayment) && prevProps.shouldUpdatePayment === nextProps.shouldUpdatePayment && prevProps.uiContext === nextProps.uiContext);
export { PersonalPayment$1 as default };
